var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 186,
    viewBox: "0 0 200 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 186
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.98 53.6888L81.2974 48.9122L94.0031 51.0139L101.359 58.8475L102.792 71.8397L96.4869 81.9661L84.45 87.6025L73.0817 85.4052L64.9615 76.4253L63.9107 65.1525L70.98 53.6888Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0031 51.0139L81.2974 48.9122L98.2065 15.3806L109.957 17.1002L94.0031 51.0139Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.359 58.8475L138.234 13.661L94.0031 51.0139L101.359 58.8475Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.957 17.1002L138.234 13.661L94.0031 51.0139L109.957 17.1002Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5485 3.05701L98.2065 15.3806L81.2974 48.9122L54.5485 3.05701Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.98 53.6888L81.2974 48.9122L54.5485 3.05701L70.98 53.6888Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5562 43.2758L54.5485 3.05701L70.98 53.6888L41.5562 43.2758Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9107 65.1525L70.98 53.6888L41.5562 43.2758L35.4422 53.6888L63.9107 65.1525Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3175 75.661L63.9107 65.1525L35.4422 53.6888L10.3175 75.661Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9769 47.5747L28.2773 52.3513L33.3405 55.4083L35.4422 53.6888L38.9769 47.5747Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5701 57.8921L28.2773 52.3513L33.3405 55.4083L30.5701 57.8921Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9615 76.4253L10.3175 75.661L63.9107 65.1525L64.9615 76.4253Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3082 115.02L64.9615 76.4253L10.3175 75.661L38.3082 115.02Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0817 85.4052L64.9615 76.4253L38.3082 115.02L45.8551 124.096L73.0817 85.4052Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3175 75.661L38.3082 115.02L33.1495 111.676L10.3175 75.661Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8551 124.096L38.3082 115.02L33.1495 111.676L30.9523 114.16L32.6718 121.039L37.6395 130.305L43.849 137.565L49.8675 142.151L52.1603 140.336L50.9184 133.267L45.8551 124.096Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8521 81.1063L0 96.9646L30.9523 114.16L33.1495 111.676L13.8521 81.1063Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6718 121.039L0 96.9646L30.9523 114.16L32.6718 121.039Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0817 85.4052L63.2419 139.19L45.8551 124.096L73.0817 85.4052Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45 87.6025L73.0817 85.4052L63.2419 139.19L84.45 87.6025Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8551 124.096L63.2419 139.19L50.9184 133.267L45.8551 124.096Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45 87.6025L109.288 137.948L63.2419 139.19L84.45 87.6025Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6395 130.305L33.1494 154.952L43.849 137.565L37.6395 130.305Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.288 137.948L103.365 144.635L63.2419 139.19L109.288 137.948Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1603 140.336L103.461 152.086L103.365 144.635L63.2419 139.19L50.9184 133.267L52.1603 140.336Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4576 186L52.1603 140.336L49.8675 142.151L71.4576 186Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1494 154.952L43.849 137.565L49.8675 142.151L55.8859 154.475L33.1494 154.952Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1603 140.336L103.461 152.086L71.4576 186L52.1603 140.336Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45 87.6025L96.4869 81.9661L121.325 132.407L109.288 137.948L84.45 87.6025Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.461 152.086L109.67 155.525L120.752 154.952L130.592 151.035L137.565 143.584L138.139 136.897L131.26 132.407H121.325L109.288 137.948L103.365 144.635L103.461 152.086Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4576 186L103.461 152.086L109.67 155.525L71.4576 186Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4869 81.9661L147.883 101.359L121.325 132.407L96.4869 81.9661Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.792 71.8397L147.883 101.359L96.4869 81.9661L102.792 71.8397Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.359 58.8475L138.234 13.661L154.092 60.9492L101.359 58.8475Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.792 71.8397L155.525 73.4638L154.092 60.9492L101.359 58.8475L102.792 71.8397Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.883 101.359L155.525 73.4638L102.792 71.8397L147.883 101.359Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.752 154.952L140.431 180.746L130.592 151.035L120.752 154.952Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.883 101.359L131.26 132.407H121.325L147.883 101.359Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.67 155.525L120.752 154.952L102.887 160.875L109.67 155.525Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.431 180.746L120.752 154.952L102.887 160.875L140.431 180.746Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.565 143.584L189.344 135.177L138.139 136.897L137.565 143.584Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.592 151.035L145.495 142.342L137.565 143.584L130.592 151.035Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.431 180.746L152.659 141.291L145.495 142.342L130.592 151.035L140.431 180.746Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.525 73.4638L154.092 60.9492L156.385 54.1664L161.544 53.6888L166.703 58.8475L170.906 69.4515L172.339 79.1957L170.619 87.6025L165.938 89.322L160.111 83.7812L155.525 73.4638Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.139 136.897L165.938 89.322L189.344 135.177L138.139 136.897Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.619 87.6025L189.344 135.177L165.938 89.322L170.619 87.6025Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.26 132.407L147.883 101.359L160.111 83.7812L165.938 89.322L138.139 136.897L131.26 132.407Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.525 73.4638L160.111 83.7812L147.883 101.359L155.525 73.4638Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.339 79.1957L199.088 80.6287L170.906 69.4515L172.339 79.1957Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.116 104.034L199.088 80.6287L172.339 79.1957L170.619 87.6025L177.116 104.034Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.906 69.4515L199.088 80.6287L168.9 64.2928L170.906 69.4515Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.234 13.661L156.385 54.1664L154.092 60.9492L138.234 13.661Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.703 58.8475L173.199 13.661L161.544 53.6888L166.703 58.8475Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.131 42.416L161.544 53.6888L156.385 54.1664L151.131 42.416Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.199 13.661L139.476 16.527L151.131 42.416L161.544 53.6888L173.199 13.661Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2065 15.3806L109.957 17.1002L116.166 16.2404L107.569 14.3297L96.8691 13.2789L91.5193 13.4699L98.2065 15.3806Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.726 14.9985L122.567 6.01849L116.166 16.2404L127.726 14.9985Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.569 14.3297L122.567 6.01849L116.166 16.2404L107.569 14.3297Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4145 3.82126L59.134 0L91.8058 13.47L57.4145 3.82126Z",
    fill: "#B7B7B7"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.98 53.6887L81.2974 48.9122L94.0031 51.0139L101.359 58.8475L102.792 71.8397L96.4869 81.9661L84.4499 87.6025L73.0817 85.4052L64.9615 76.4253L63.9106 65.1525L70.98 53.6887Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0031 51.0139L81.2974 48.9122L98.2065 15.3806L109.957 17.1002L94.0031 51.0139Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.359 58.8475L138.234 13.661L94.0031 51.0139L101.359 58.8475Z",
    fill: "#9C9C9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.957 17.1001L138.234 13.661L94.0031 51.0139L109.957 17.1001Z",
    fill: "#AAAAAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5485 3.05701L98.2064 15.3806L81.2973 48.9122L54.5485 3.05701Z",
    fill: "#EEEEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9799 53.6887L81.2973 48.9122L54.5485 3.05701L70.9799 53.6887Z",
    fill: "#A7A7A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5563 43.2758L54.5486 3.05701L70.98 53.6887L41.5563 43.2758Z",
    fill: "#848484"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9106 65.1525L70.9799 53.6888L41.5562 43.2758L35.4421 53.6888L63.9106 65.1525Z",
    fill: "#A3A3A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3175 75.661L63.9107 65.1525L35.4423 53.6887L10.3175 75.661Z",
    fill: "#C3C3C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9769 47.5747L28.2773 52.3513L33.3405 55.4083L35.4422 53.6887L38.9769 47.5747Z",
    fill: "#A3A3A3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5701 57.8921L28.2773 52.3513L33.3405 55.4083L30.5701 57.8921Z",
    fill: "#757575"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9616 76.4253L10.3175 75.661L63.9107 65.1525L64.9616 76.4253Z",
    fill: "#C1C1C1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3083 115.02L64.9616 76.4253L10.3175 75.661L38.3083 115.02Z",
    fill: "#6B6B6B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0816 85.4053L64.9614 76.4253L38.3081 115.02L45.8551 124.096L73.0816 85.4053Z",
    fill: "#818181"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3175 75.661L38.3083 115.02L33.1496 111.676L10.3175 75.661Z",
    fill: "#636363"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8552 124.095L38.3082 115.02L33.1495 111.676L30.9523 114.16L32.6718 121.038L37.6395 130.305L43.849 137.565L49.8675 142.151L52.1603 140.336L50.9184 133.267L45.8552 124.095Z",
    fill: "#6D6D6D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8521 81.1063L0 96.9646L30.9522 114.16L33.1495 111.676L13.8521 81.1063Z",
    fill: "#939393"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6718 121.038L0 96.9645L30.9522 114.16L32.6718 121.038Z",
    fill: "#666666"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0817 85.4052L63.242 139.189L45.8552 124.095L73.0817 85.4052Z",
    fill: "#9A9A9A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4498 87.6024L73.0816 85.4052L63.2418 139.189L84.4498 87.6024Z",
    fill: "#C5C5C5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8552 124.096L63.242 139.19L50.9184 133.267L45.8552 124.096Z",
    fill: "#656565"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4498 87.6025L109.288 137.948L63.2418 139.19L84.4498 87.6025Z",
    fill: "#CFCFCF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6394 130.305L33.1494 154.952L43.849 137.565L37.6394 130.305Z",
    fill: "#747474"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M109.288 137.948L103.365 144.635L63.2418 139.19L109.288 137.948Z",
    fill: "#727272"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1602 140.336L103.461 152.086L103.365 144.635L63.2419 139.19L50.9183 133.267L52.1602 140.336Z",
    fill: "#4A4A4A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4576 186L52.1602 140.336L49.8674 142.151L71.4576 186Z",
    fill: "#797979"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1494 154.952L43.849 137.565L49.8674 142.151L55.8859 154.475L33.1494 154.952Z",
    fill: "#424242"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1603 140.336L103.461 152.086L71.4577 186L52.1603 140.336Z",
    fill: "#6A6A6A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.45 87.6025L96.4869 81.9661L121.325 132.407L109.288 137.948L84.45 87.6025Z",
    fill: "#7A7A7A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.461 152.086L109.67 155.525L120.752 154.952L130.592 151.035L137.565 143.584L138.139 136.897L131.26 132.407H121.325L109.288 137.948L103.365 144.635L103.461 152.086Z",
    fill: "#6B6B6B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4576 186L103.461 152.086L109.67 155.525L71.4576 186Z",
    fill: "#858585"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4869 81.9661L147.883 101.359L121.325 132.407L96.4869 81.9661Z",
    fill: "#737373"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102.792 71.8397L147.883 101.359L96.4869 81.9661L102.792 71.8397Z",
    fill: "#ADADAD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M101.359 58.8475L138.234 13.661L154.092 60.9491L101.359 58.8475Z",
    fill: "#9F9F9F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M102.792 71.8398L155.525 73.4638L154.092 60.9492L101.359 58.8475L102.792 71.8398Z",
    fill: "#DEDEDE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M147.883 101.359L155.525 73.4638L102.792 71.8397L147.883 101.359Z",
    fill: "#EBEBEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M120.752 154.952L140.431 180.746L130.592 151.035L120.752 154.952Z",
    fill: "#737373"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M147.883 101.359L131.26 132.407H121.325L147.883 101.359Z",
    fill: "#515151"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M109.67 155.525L120.752 154.952L102.887 160.875L109.67 155.525Z",
    fill: "#2E2E2E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.431 180.746L120.752 154.952L102.887 160.875L140.431 180.746Z",
    fill: "#454545"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M137.565 143.584L189.344 135.177L138.139 136.897L137.565 143.584Z",
    fill: "#5A5A5A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M130.592 151.035L145.495 142.342L137.565 143.584L130.592 151.035Z",
    fill: "#484848"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M140.431 180.746L152.659 141.291L145.495 142.342L130.592 151.035L140.431 180.746Z",
    fill: "#D7D7D7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M155.526 73.4638L154.093 60.9491L156.385 54.1664L161.544 53.6887L166.703 58.8474L170.906 69.4514L172.339 79.1957L170.619 87.6024L165.938 89.322L160.111 83.7812L155.526 73.4638Z",
    fill: "#FAFAFA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M138.139 136.897L165.938 89.322L189.344 135.177L138.139 136.897Z",
    fill: "#B4B4B4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M170.619 87.6025L189.344 135.177L165.938 89.322L170.619 87.6025Z",
    fill: "#F1F1F1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M131.26 132.407L147.883 101.359L160.111 83.7812L165.938 89.322L138.139 136.897L131.26 132.407Z",
    fill: "#CACACA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M155.525 73.4638L160.111 83.7812L147.883 101.359L155.525 73.4638Z",
    fill: "#F4F4F4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M172.339 79.1957L199.088 80.6287L170.906 69.4515L172.339 79.1957Z",
    fill: "#EAEAEA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M177.116 104.034L199.088 80.6287L172.339 79.1957L170.619 87.6025L177.116 104.034Z",
    fill: "#A1A1A1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M170.906 69.4515L199.088 80.6287L168.9 64.2928L170.906 69.4515Z",
    fill: "#F0F0F0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M138.234 13.661L156.385 54.1664L154.092 60.9491L138.234 13.661Z",
    fill: "#E6E6E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M166.703 58.8475L173.199 13.661L161.544 53.6887L166.703 58.8475Z",
    fill: "#E4E4E4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M151.131 42.416L161.544 53.6887L156.385 54.1664L151.131 42.416Z",
    fill: "#F5F5F5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M173.199 13.661L139.476 16.527L151.131 42.416L161.544 53.6887L173.199 13.661Z",
    fill: "#D0D0D0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2065 15.3806L109.957 17.1001L116.166 16.2403L107.569 14.3297L96.8691 13.2789L91.5193 13.4699L98.2065 15.3806Z",
    fill: "#ECECEC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M127.726 14.9985L122.567 6.01849L116.166 16.2404L127.726 14.9985Z",
    fill: "#F1F1F1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M107.569 14.3297L122.567 6.01849L116.166 16.2404L107.569 14.3297Z",
    fill: "#E8E8E8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4144 3.82126L59.134 0L91.8058 13.47L57.4144 3.82126Z",
    fill: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 186,
    fill: "#30D4DE",
    fillOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel4);
export default __webpack_public_path__ + "static/media/level4.5562d147bbfdf8d87c6a93f05b34eb15.svg";
export { ForwardRef as ReactComponent };